import { css } from '@emotion/react'

const styles = css`
  font-size: 15px;
`

export default styles
